import { Params } from '../models/response'
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpXhrBackend } from '@angular/common/http';
import { Injectable , Inject } from '@angular/core';
import { error } from 'console';


/**
 * Servicio Consulta APIRest,
 * Permite obtener los datos de los servicios API
*/

@Injectable({ providedIn: 'root' })
export class ApiService {
  public uri: string;
  public dataJSon: any | null = null;
  public method: string;
  public invokeStatus: string | null = null;
  
  
  private APIKEY: string = `${environment.apiKey}`;
 
  constructor(@Inject('uri') public Uri: string,
              @Inject('method') public Method: string,
              private httpClient: HttpClient
              ) {
    this.uri = Uri;
    this.method = Method;
  }

  public async getJSonResponse(): Promise<any> {
    let responseFromServer: string | Object;

    try {
        let user = JSON.parse(localStorage.getItem("user"));

        let headers = new HttpHeaders();
        headers = headers.set('Authorization', user.Token);
        headers = headers.set('ApiKey',this.APIKEY);
                                       
        headers = headers.set('CeqUser', user.Email);
        headers = headers.set('CeqToken', user.Token);
        headers = headers.set('ClientOrigin', 'WEB');
        
        if (this.method === "GET") {
            responseFromServer = await this.httpClient.get(this.uri, { headers: headers }).toPromise();
        } else if(this.method === "POST") {
            responseFromServer = await this.httpClient.post(this.uri, this.dataJSon, { headers: headers}).toPromise();
        } else if(this.method === "PUT") {
            responseFromServer = await this.httpClient.put(this.uri, this.dataJSon, { headers: headers}).toPromise();
        } else if(this.method === "DELETE") {
            responseFromServer = await this.httpClient.delete(this.uri, { headers: headers}).toPromise();
        }

    } catch (ex) {
        var exResponse = ex as HttpErrorResponse;
        if (exResponse!.error !== '') {
            responseFromServer = JSON.stringify({ Success: 0, Error_msg: exResponse.error, Error_code: 404, Response:'Error' });
        }
        else if(exResponse!.message !== '') {
            responseFromServer = JSON.stringify({ Success: 0, Error_msg: exResponse.message, Error_code: 404, Response: exResponse.message });
        }
        
        console.error("Application_Error: GetJSonResponse ", ex);
    }

    return responseFromServer;
}
}

@Injectable({ providedIn: 'root' })
export class ProxyGet {
  //Funcion de consulta API para obtner sucursales
    private responseJSon: any | null = null;
    private WcfeCommerce: ApiService | null = null;
    private URLResponse: string = environment.production ? `${window.location.protocol}//${window.location.host}${environment.services_url}${environment.service_version}`: `${environment.services_url}${environment.service_version}`;

    public getWcfeCommerce1(): ApiService | null {
        return this.WcfeCommerce;
    }

    public setWcfeCommerce1(value: ApiService): void {
        this.WcfeCommerce = value;
    }

    public getJson(): any {
        return this.WcfeCommerce.dataJSon;
    }

    public setJson(value: any): void {
        this.WcfeCommerce.dataJSon = value;
    }

    

    public async callAPI(service: string, method: string): Promise<any> {
        try {
            const httpClient = new HttpClient(new HttpXhrBackend({ 
                build: () => new XMLHttpRequest() 
            }));
            this.setWcfeCommerce1(new ApiService( `${this.URLResponse}${service}`,method, httpClient));
          this.responseJSon = await this.getWcfeCommerce1()!.getJSonResponse();
          return this.responseJSon;
          
        } catch (ex) {
            console.error("Application_Error: ProxyGet-Controller ", ex);
        }
        
    }

    public async callAPIWithParams(service: string, method: string, param: Params): Promise<any> {
        const requestJSon: Record<string, any> = {};
        try {
            const httpClient = new HttpClient(new HttpXhrBackend({ 
                build: () => new XMLHttpRequest() 
            }));
            const requestJSon2: Record<string, any> = {};
            for (const p of param.Parameter) {
                requestJSon[p.Field] = p.Object ?? p.Value;
            }

            requestJSon2["Args"] = requestJSon;
            
            this.setWcfeCommerce1(new ApiService(`${this.URLResponse}${service}`,method,httpClient));
            this.setJson(requestJSon2);
            this.responseJSon = await this.getWcfeCommerce1()!.getJSonResponse();
            return this.responseJSon;
        } catch (ex) {
            console.error("Application_Error: ProxyGet-Controller ", ex);
        }
        
    }

    /**
     * Invoca un endpoint enviando un objeto en el cuerpo de la petición
     * @param service url del endpoint
     * @param method tipo de peticion (GET, POST, PUT, DELETE)
     * @param body objeto que se enviara en el cuerpo de la petición
     * @returns 
     */
    public async callAPIWithBody(service: string, method: string, body: any): Promise<any> {
        const requestJSon: Record<string, any> = {};
        try {
            const httpClient = new HttpClient(new HttpXhrBackend({ 
                build: () => new XMLHttpRequest() 
            }));
            this.setWcfeCommerce1(new ApiService(`${this.URLResponse}${service}`, method,httpClient));
            this.setJson(body);
            this.responseJSon = await this.getWcfeCommerce1()!.getJSonResponse();
            return this.responseJSon;
        } catch (ex) {
            console.error("Application_Error: ProxyGet-Controller ", ex);
        }

    }
}